import axios from "axios";
import { getAuthHeaders } from "./auth";
import { ReviewDefaults } from "../types/review";

const BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "http://localhost:7071/api";

/**
 * Fetch the public (non-admin-gated) reviewer-facing defaults from system_settings.
 * Currently returns the Approve / Deny default justifications. Adding a new
 * field here requires extending the backend allowlist in `publicConfigApi.ts`
 * AND `04-Data-Model.md` — default is admin-only.
 */
export async function getPublicConfig(): Promise<ReviewDefaults> {
  const resp = await axios.get(`${BASE_URL}/config/public`, { headers: getAuthHeaders() });
  return resp.data as ReviewDefaults;
}
